import {
  Card,
  CardContent,
  CardHeader,
  Accordion as ExpansionPanel,
  AccordionDetails as ExpansionPanelDetails,
  AccordionSummary as ExpansionPanelSummary,
  Checkbox,
  Grid,
  IconButton,
  Select,
  FormControl,
  MenuItem,
  FormControlLabel,
  Switch,
  TextField,
  Tooltip
} from '@mui/material';
import { Title, Text, ButtonOptions } from 'shared/components';
import Autocomplete from '@mui/lab/Autocomplete';
import {
  ExpandMore as ExpandMoreIcon,
  Help as HelpIcon,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon
} from '@mui/icons-material';

import React from 'react';
import PropTypes from 'prop-types';
import { getHelpText } from '../../utils/cube/constants';

import useStyles from './styles';

const CardSettingsImpacts = ({
  options,
  form,
  handleChangeForm,
  indicators,
  portfolios,
  services,
}) => {
  const classes = useStyles();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  return (
    <>
      <TextField
        label="Display name (optional)"
        value={form.customName}
        onChange={e => handleChangeForm('customName', e.target.value)}
        variant="outlined"
        size="small"
        fullWidth
        inputProps={{ style: { fontSize: 14 } }}
      />
      <ExpansionPanel className={classes.expansionPanel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Metric</Title>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <Tooltip title={getHelpText('General')}>
                  <IconButton aria-label="help">
                    <HelpIcon />
                  </IconButton>
                </Tooltip>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  What data do you want to display?
                </Text>
              }
            />
            <CardContent className={classes.cardContent}>
              <Grid container spacing={1}>
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    titleMarging={20}
                    options={options.IMPACTS_METRIC}
                    onChange={value => handleChangeForm('metric', value)}
                    value={form.metric}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </ExpansionPanelDetails>
        {form.metric === 'Total claim' && (
          <ExpansionPanelDetails>
            <Card className={classes.rootSubCard}>
              <CardHeader
                action={
                  <Tooltip title={getHelpText('Include Catalyzed Claim')}>
                    <IconButton aria-label="help">
                      <HelpIcon />
                    </IconButton>
                  </Tooltip>
                }
                subheader={
                  <Text className={classes.subHeaderSubCard}>
                    Include Catalized Claim
                  </Text>
                }
              />
              <CardContent className={classes.cardContent}>
                <Grid container spacing={1}>
                  <Grid item xs={12} className={classes.gutterBottomCardRow}>
                    <FormControl className={classes.selectContainer}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={form.catalized}
                            onChange={() =>
                              handleChangeForm('catalized', !form.catalized)
                            }
                            name="Catalized Claim"
                            color="primary"
                          />
                        }
                        label="Catalized Claim"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </ExpansionPanelDetails>
        )}
      </ExpansionPanel>
      <ExpansionPanel className={classes.expansionPanel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Segment</Title>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <Tooltip title={getHelpText('General')}>
                  <IconButton aria-label="help">
                    <HelpIcon />
                  </IconButton>
                </Tooltip>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  How do you want to group the data? (Calculations will be made
                  separately for each group displayed side-by-side)
                </Text>
              }
            />
            <CardContent className={classes.cardContent}>
              <Grid container spacing={1}>
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    titleMarging={20}
                    options={options.IMPACTS_SEGMENTS}
                    onChange={value => handleChangeForm('segment', value)}
                    value={form.segment}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel className={classes.expansionPanel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Filters</Title>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Card className={classes.rootSubCard}>
                <CardHeader
                  action={
                    <Tooltip title={getHelpText('General')}>
                      <IconButton aria-label="help">
                        <HelpIcon />
                      </IconButton>
                    </Tooltip>
                  }
                  subheader={
                    <Text className={classes.subHeaderSubCard}>
                      What data do you want to include?
                    </Text>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    style={{ textAlign: 'left' }}
                  >
                    <Grid item xs={6} className={[classes.gutterBottomCardRow, classes.flexAuto]}>
                      <ButtonOptions
                        titleMarging={20}
                        optionsObject={options.YEAR}
                        options={options.FILTER_IMPACTS}
                        onChange={value => handleChangeForm('filter', value)}
                        float
                        value={form.filter}
                        otherHelpText={getHelpText('Other Year')}
                        optionsTextHelper={getHelpText}
                      />
                    </Grid>
                    <Grid item xs={6} className={classes.gutterBottomCardRow}>
                      <ButtonOptions
                        titleMarging={20}
                        options={options.STATUS}
                        onChange={value => handleChangeForm('status', value)}
                        float
                        value={form.status}
                        optionsTextHelper={getHelpText}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* portfolios */}
              <Card className={classes.rootSubCard}>
                <CardHeader
                  action={
                    <Tooltip title={getHelpText('Portfolio')}>
                      <IconButton aria-label="help">
                        <HelpIcon />
                      </IconButton>
                    </Tooltip>
                  }
                  subheader={
                    <Text className={classes.subHeaderSubCard}>
                      Add Portfolios
                    </Text>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    style={{ textAlign: 'left' }}
                  >
                    <Grid item xs={12} className={classes.gutterBottomCardRow}>
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        size="small"
                        options={portfolios}
                        value={form.portfolios}
                        onChange={(event, value) =>
                          handleChangeForm('portfolios', value)
                        }
                        disableCloseOnSelect
                        getOptionLabel={option => option}
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              className={classes.checkboxAutocomplete}
                              checked={selected}
                            />
                            <Text
                              variant="body1"
                              className={classes.menuItemText}
                            >
                              {option}
                            </Text>
                          </>
                        )}
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label={`Portfolios -  ${form.portfolios.length} selected`}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* portfolios end */}
              {/* services */}
              <Card className={classes.rootSubCard}>
                <CardHeader
                  action={
                    <Tooltip title={getHelpText('Selected Service')}>
                      <IconButton aria-label="help">
                        <HelpIcon />
                      </IconButton>
                    </Tooltip>
                  }
                  subheader={
                    <Text className={classes.subHeaderSubCard}>
                      Add Services
                    </Text>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    style={{ textAlign: 'left' }}
                  >
                    <Grid item xs={12} className={classes.gutterBottomCardRow}>
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        size="small"
                        options={services}
                        value={form.services}
                        onChange={(event, value) =>
                          handleChangeForm('services', value)
                        }
                        disableCloseOnSelect
                        getOptionLabel={option => option}
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              className={classes.checkboxAutocomplete}
                              checked={selected}
                            />
                            <Text
                              variant="body1"
                              className={classes.menuItemText}
                            >
                              {option}
                            </Text>
                          </>
                        )}
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label={`Services -  ${form.services.length} selected`}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* services end */}
              {/* allocation */}
              <Card className={classes.rootSubCard}>
                <CardHeader
                  action={
                    <Tooltip title={getHelpText('Allocation amount')}>
                      <IconButton aria-label="help">
                        <HelpIcon />
                      </IconButton>
                    </Tooltip>
                  }
                  subheader={
                    <Text className={classes.subHeaderSubCard}>
                      Select $ allocation amount range
                    </Text>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    style={{ textAlign: 'left' }}
                  >
                    <Grid item xs={12} className={classes.gutterBottomCardRow}>
                      <FormControl
                        variant="outlined"
                        className={classes.selectContainer}
                      >
                        <Select
                          value={form.allocation}
                          onChange={({ target: { value } }) => {
                            handleChangeForm('allocation', value);
                          }}
                          className={classes.selectText}
                        >
                          {options.ALLOCATION_AMOUNT.map(option => (
                            <MenuItem
                              key={option}
                              value={option}
                              className={classes.menuItemText}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              {/* allocation end */}
            </Grid>
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel className={classes.expansionPanel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Add Impact Indicators</Title>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <Tooltip title={getHelpText('Add Indicator')}>
                  <IconButton aria-label="help">
                    <HelpIcon />
                  </IconButton>
                </Tooltip>
              }
            />
            <CardContent className={classes.cardContent}>
              <Grid container spacing={1}>
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    size="small"
                    options={indicators}
                    value={form.indicators}
                    onChange={(event, value) =>
                      handleChangeForm('indicators', value)
                    }
                    disableCloseOnSelect
                    getOptionLabel={option => option}
                    renderOption={(option, { selected }) => (
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          className={classes.checkboxAutocomplete}
                          checked={selected}
                        />
                        <Text variant="body1" className={classes.menuItemText}>
                          {option}
                        </Text>
                      </>
                    )}
                    renderInput={params => (
                      <TextField
                        {...params}
                        style={{ textTransform: 'capitalize' }}
                        variant="outlined"
                        label={`Impact Indicators -  ${form.indicators.length} selected`}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  );
};

CardSettingsImpacts.propTypes = {
  options: PropTypes.object,
  form: PropTypes.object,
  handleChangeForm: PropTypes.func,
  indicators: PropTypes.object,
  portfolios: PropTypes.object,
  services: PropTypes.object
};

export default CardSettingsImpacts;
